import { getApi } from 'common/api-common'
import { blobbyStrings } from './strings'

const defaultStrings = {
  annualSaver: 'Annual Saver',
  apply: 'Apply',
  cantFindYourCompany: "Can't find your company?",
  cardDetail: 'Card Detail',
  cardHolder: 'Card Holder Name',
  cart: 'Cart',
  politicalOrgBlockedComplianceObligations: 'compliance obligations',
  change: 'Change',
  politicalOrgBlockedMessage:
    'Based on our service eligibility policy, Hoxton Mix cannot provide services to political organisations or certain high-risk entities, including those connected with politically exposed individuals.',
  company: 'Company',
  politicalOrgBlockedTitle: "We're unable to proceed with your application",
  companyAndContactInformation: 'Company & Contact information',
  politicalOrgBlockedUrl:
    'https://help.hoxtonmix.com/en/article/companies-and-organisations-we-dont-work-with-m2of8c/',
  contact: 'Contact',
  continueToPayment: 'Continue to Payment',
  politicalOrgBlockedModalMessage:
    "Thanks for your interest in Hoxton Mix. After reviewing your submission, we're unable to provide services in this case due to our service eligibility policy. Hoxton Mix does not provide services to political organisations, certain high-risk entities, or organisations connected with politically exposed individuals, in line with our ",
  couponError: 'Invalid coupon',
  politicalOrgBlockedSubMessage: 'We appreciate your understanding.',
  creditCard: 'Credit Card',
  directDebit: 'Direct Debit',
  discount: 'discount',
  enterCoupon: 'Enter coupon code',
  enterYourDetailsManually: 'Enter your details manually',
  enterYourPaymentDetails: 'Enter your payment details',
  error:
    'There was a problem validating your payment method, please try again.',
  goCardlessInstructions:
    'After clicking “Pay with Direct Debit”, you will be redirected to GOCARDLESS to complete your purchase',
  iAuthorisePayment:
    'I authorise The Hoxton Mix Ltd to save this payment method and automatically charge this Payment method whenever a subscription is associated with it.',
  ifYoureNotAutomaticallyRedirected:
    'Thank you for your order. Please wait while we process your payment.',
  information: 'Information',
  monthly: 'Monthly',
  payNow: 'Pay Now',
  payWith: 'Pay with',
  payment: 'Payment',

  paypal: 'PayPal',
  paypalInstructions:
    'After clicking “PayPal Check out”, you will be redirected to PayPal to complete your purchase',
  postTo: 'Post to',
  searchCompaniesHouse: 'Search Companies House for your company',
  searchCompaniesHouseCharity: 'Search charity register for your company',
  searchForCompanyDetailsAgain: 'Search for company details again',
  tellUsAboutYourCompany: 'Tell us about your company',
  tellUsAboutYourCompanyDescription:
    "To provide you with a virtual office, we need to verify your details. It's necessary to do this to comply with Anti-money laundering laws.",
  thanksSeoTitle: 'Thank you for your order | Hoxton Mix',
  thisIsSecure256BitSslEncryptedPayment:
    'This is a secure 256-bit SSL Encrypted payment. You’re safe.',
  transactionsAreSecure: 'All transactions are secure and encrypted.',
  typeCharityNameHere: 'Type charity name here',
  typeCompanyNameHere: 'Type company name here',
  whereToSendInCaseYouRequirePhysicalCopy:
    'Sometimes you might want your mail forwarded to your physical address, such as a bank card. Please specify your physical address.',
  whereToSendPostDescription:
    'Please enter the address below of where we should send your post',
  yourOrderIsBeingProcessed: 'Your order is being processed.',
}
export const paymentStrings = getApi().makeStrings({
  en: defaultStrings,
  es: blobbyStrings(defaultStrings),
})
